import axios from 'axios'

export const notifySlack = async (payload) => {
    console.log("notifySlack", payload)
    try {
        if (!process.env.REACT_APP_SLACK_LAMBDA_URL) {
            console.warn("SLACK_LAMBDA_URL not configured, skipping notification")
            return
        }

        if (!process.env.REACT_APP_SLACK_ALERT_WEBHOOK_URL) {
            console.warn("SLACK_ALERT_WEBHOOK_URL not configured, skipping notification")
            return
        }
        
        // Lambda expects: { hook: "webhook-url", payload: { blocks: [...] } }
        const lambdaPayload = {
            hook: process.env.REACT_APP_SLACK_ALERT_WEBHOOK_URL,
            payload
        }
        
        axios.post(`${process.env.REACT_APP_SLACK_LAMBDA_URL}`, JSON.stringify(lambdaPayload), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => console.log("notifiedSlack", response))
            .catch(err => console.error("Error sending Slack notification", err))
    } catch (error) {
        console.log("error", error)
    }
}

export function getSlackBlock(data, type, error) {
    let block = {}

    if (type === 'error') {
        const fields = [
            {
                type: "mrkdwn",
                text: "*Product:* Facebook Onboarding"
            },
            {
                type: "mrkdwn",
                text: "*Type:* :fire: Error"
            }
        ]

        // Add context field if provided
        if (data.context) {
            fields.push({
                type: "mrkdwn",
                text: `*Context:* ${data.context}`
            })
        }

        // Add venue/brand info if available
        if (data.venueId || data.brandId) {
            fields.push({
                type: "mrkdwn",
                text: `*ID:* ${data.venueId || data.brandId || 'N/A'}`
            })
        }

        // Add RMS info if available
        if (data.rms) {
            fields.push({
                type: "mrkdwn",
                text: `*RMS:* ${data.rms}`
            })
        }

        block = {
            blocks: [
                {
                    type: 'header',
                    text: {
                        type: 'plain_text',
                        text: 'Issue detected with FB Onboarding',
                        emoji: true
                    }
                },
                {
                    type: "section",
                    fields
                },
                {
                    type: "divider"
                },
                {
                    type: "section",
                    text: {
                        type: "mrkdwn",
                        text: `*Error message:*\n\`\`\`${error}\`\`\``
                    }
                },
                {
                    type: "section",
                    text: {
                        type: "mrkdwn",
                        text: "*Actions:*\n Requires manual action from the @engineering-team to review the error."
                    }
                }
            ]
        }
        
        // Add URL button if redirect URL is provided
        if (data.redirectUrl) {
            block.blocks[block.blocks.length - 1].accessory = {
                type: "button",
                text: {
                    type: "plain_text",
                    text: "View Redirect URL",
                    emoji: true
                },
                value: "redirect_url",
                url: `${data.redirectUrl}`,
                action_id: "button-action"
            }
        }
    } else if (type === 'auth_error') {
        block = {
            blocks: [
                {
                    type: 'header',
                    text: {
                        type: 'plain_text',
                        text: 'Authentication Error - FB Onboarding',
                        emoji: true
                    }
                },
                {
                    type: "section",
                    fields: [
                        {
                            type: "mrkdwn",
                            text: "*Product:* Facebook Onboarding"
                        },
                        {
                            type: "mrkdwn",
                            text: "*Type:* :warning: Auth Issue"
                        },
                        {
                            type: "mrkdwn",
                            text: `*Provider:* ${data.provider || 'Unknown'}`
                        },
                        {
                            type: "mrkdwn",
                            text: `*Provider Key:* ${data.providerKey || 'N/A'}`
                        }
                    ]
                },
                {
                    type: "divider"
                },
                {
                    type: "section",
                    text: {
                        type: "mrkdwn",
                        text: `*Error message:*\n\`\`\`${error}\`\`\``
                    }
                },
                {
                    type: "section",
                    text: {
                        type: "mrkdwn",
                        text: "*Actions:*\n Check provider configuration and SSO credentials."
                    }
                }
            ]
        }
    } else if (type === 'venue_not_found') {
        block = {
            blocks: [
                {
                    type: 'header',
                    text: {
                        type: 'plain_text',
                        text: 'Venue Not Found - FB Onboarding',
                        emoji: true
                    }
                },
                {
                    type: "section",
                    fields: [
                        {
                            type: "mrkdwn",
                            text: "*Product:* META Reservations"
                        },
                        {
                            type: "mrkdwn",
                            text: "*Type:* :muscle: Actionable"
                        },
                        {
                            type: "mrkdwn",
                            text: `*RMS ID:* ${data.rms || 'Unknown'}`
                        },
                        {
                            type: "mrkdwn",
                            text: `*Venue ID:* ${data.venueId || 'Unknown'}`
                        }
                    ]
                },
                {
                    type: "divider"
                },
                {
                    type: "section",
                    text: {
                        type: "mrkdwn",
                        text: `*Error message:*\n\`\`\`Venue not found or cannot be setup\n\nDetails: ${error}\`\`\``
                    }
                },
                {
                    type: "section",
                    text: {
                        type: "mrkdwn",
                        text: "*Actions:*\n Requires manual action from the @engineering-team to verify venue exists in database and has proper META configuration."
                    }
                }
            ]
        }
    }

    return block
}

export const notifyError = (data, type = 'error', error) => {
    const block = getSlackBlock(data, type, error)
    notifySlack(block)
}

export const sendLogs = (message, context = 'FB Onboarding') => {
    // Check if logging is enabled
    if (process.env.REACT_APP_SLACK_LOGGING_ENABLED !== 'true') {
        console.log('[Slack Logging Disabled]', message)
        return
    }

    console.log('[Slack Log]', message)

    const logBlock = {
        blocks: [
            {
                type: 'section',
                text: {
                    type: 'mrkdwn',
                    text: `*[${context}]*\n${message}`
                }
            },
            {
                type: 'context',
                elements: [
                    {
                        type: 'mrkdwn',
                        text: `_${new Date().toISOString()}_`
                    }
                ]
            }
        ]
    }

    notifySlack(logBlock)
}
